import React, { useState, useEffect } from "react";
import Button from "./Button";
import { useApp } from "../contexts/AppContext";
function DataTable({ data, columns, actions, defaultcolumn }) {
  const { isOwner } = useApp();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if (data) {
      const filtered = data.filter((record) => {
        const values = Object.values(record).map((value) =>
          typeof value === "string"
            ? value.toLowerCase()
            : value.toString().toLowerCase()
        );
        const stringMatch = values.some(
          (value) =>
            typeof value === "string" &&
            value.includes(searchQuery.toLowerCase())
        );
        const numberMatch = values.some((value) => {
          if (typeof value === "number") {
            return value.toString().includes(searchQuery);
          }
          return false;
        });

        return stringMatch || numberMatch;
      });
      setFilteredData(filtered);
      setCurrentPage(0);
    }
  }, [data, searchQuery]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const itemsPerPage = 5;
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const records = filteredData.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
  };

  const previousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Search..."
        value={searchQuery}
        onChange={handleSearchChange}
        className="mt-4 p-2 border border-gray-300 rounded-md"
      />
      <div className="w-full overflow-x-scroll md:overflow-auto max-w-7xl 2xl:max-w-none mt-2">
        <table className="table-auto overflow-scroll md:overflow-auto w-full text-left font-inter border">
          <thead className="rounded-lg text-base text-white font-semibold w-full">
            <tr className="bg-[#222E3A]/[6%]">
              {defaultcolumn && (
                <th className="py-3 px-3 text-[#212B36] sm:text-base font-bold whitespace-nowrap">
                  SNo
                </th>
              )}
              {columns.map((column, index) => (
                <th
                  key={index}
                  className="py-3 px-3 text-[#212B36] sm:text-base font-bold whitespace-nowrap"
                >
                  {column.header}
                </th>
              ))}

              {actions && (
                <th className="py-3 px-3 text-[#212B36] sm:text-base font-bold whitespace-nowrap">
                  Actions
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {records && records.length > 0 ? (
              records.map((row, rowIndex) => (
                <tr className="bg-white" key={rowIndex}>
                  {defaultcolumn && (
                    <td
                      key={rowIndex}
                      className={`py-2 px-3 font-normal text-base ${
                        rowIndex === 0 ? "border-t-2 border-black" : "border-t"
                      } whitespace-nowrap`}
                    >
                      {rowIndex + 1}
                    </td>
                  )}
                  {columns.map((column, colIndex) => (
                    <td
                      key={colIndex}
                      className={`py-2 px-3 font-normal text-base ${
                        rowIndex === 0 ? "border-t-2 border-black" : "border-t"
                      } whitespace-nowrap`}
                    >
                      {row[column.key]}
                    </td>
                  ))}
                  <td
                    className={`py-5 px-4 text-base font-normal ${
                      rowIndex === 0 ? "border-t-2 border-black" : "border-t"
                    }`}
                  >
                    {isOwner &&
                      actions &&
                      actions.map((action, actionIndex) => (
                        <Button
                          key={actionIndex}
                          buttonProps={{
                            className: `hover:bg-gray-100 rounded-md p-2 hover:text-${action.color}-600`,
                            onClick: () => action.onClick(row),
                          }}
                        >
                          {action.icon}
                        </Button>
                      ))}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={defaultcolumn ? columns.length + 1 : columns.length}
                >
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="flex items-center justify-center mt-4">
          <button
            onClick={previousPage}
            disabled={currentPage === 0}
            className="mr-2 px-3 py-1 rounded-md bg-gray-200 text-gray-700 disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-gray-700 mr-2">
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            onClick={nextPage}
            disabled={currentPage === totalPages - 1}
            className="ml-2 px-3 py-1 rounded-md bg-gray-200 text-gray-700 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
export default DataTable;
